import Loader from 'react-loader-spinner';
import { ButtonInterface } from '../../types/misc';

const TertiaryButton = ({
	type = 'button',
	disabled = false,
	children,
	handleClick,
	spin = true,
	grow = false,
}: ButtonInterface) => {
	return (
		<button
			type={type}
			disabled={disabled}
			onClick={handleClick}
			className={`my-4 py-4 ${
				grow ? 'w-full' : 'w-fit'
			} px-16 font-bold bg-transparent ring-2 ring-gray-400 text-gray-600 ${
				disabled && `ring-gray-300 text-gray-400`
			} rounded-2xl shadow-box relative ${
				!disabled &&
				'active:shadow-box-none active:transform active:translate-y-1 active:translate-x-1 transition-all ease-out duration-200'
			}`}
		>
			{children}{' '}
			{disabled && spin && (
				<div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
					<Loader type='TailSpin' color='#00BFFF' height={40} width={40} />
				</div>
			)}
		</button>
	);
};

// disabled && spin &&

export default TertiaryButton;
